import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCuba = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_46)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.25e-05 2.08698H0V21.913H6.25e-05V12.0001V2.08698Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6273 24 23.9999 18.6274 23.9999 12C23.9999 5.37262 18.6273 6.10352e-05 12 6.10352e-05C5.37256 6.10352e-05 0 5.37262 0 12C0 18.6274 5.37256 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 9.15527e-05C8.07417 9.15527e-05 4.58883 1.88555 2.39953 4.80009H21.6005C19.4113 1.8855 15.9259 9.15527e-05 12 9.15527e-05Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 23.9999C15.9259 23.9999 19.4113 22.1145 21.6006 19.1999H2.39953C4.58878 22.1145 8.07417 23.9999 12 23.9999Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.57764e-05 12C4.57764e-05 12.822 0.0829208 13.6246 0.240374 14.4H23.7598C23.9172 13.6246 24 12.822 24 12C24 11.1781 23.9172 10.3755 23.7598 9.60004H0.240374C0.0829208 10.3755 4.57764e-05 11.1781 4.57764e-05 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51474 3.51479C-1.1715 8.20102 -1.1715 15.799 3.51474 20.4854C5.45128 18.5488 7.31372 16.6863 12 12.0001L3.51474 3.51479Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.85676 8.86964L5.63367 11.261H8.14832L6.11409 12.739L6.891 15.1304L4.85676 13.6524L2.82243 15.1304L3.59953 12.739L1.56525 11.261H4.07972L4.85676 8.86964Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_46",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCuba;
